import { SubscriptionPlanType } from '../SubscriptionPlans/constants';

export const SUBSCRIPTION_PLAN_STATUS_ACTIVE = 'active';
export const SUBSCRIPTION_PLAN_STATUS_TRIAL = 'trial';
export const SUBSCRIPTION_PLAN_STATUS_CANCEL_PENDING = 'cancel_pending';
export const SUBSCRIPTION_PLAN_STATUS_CANCELLED = 'cancelled';
export const SUBSCRIPTION_PLAN_STATUS_EXPIRED = 'expired';
export const SUBSCRIPTION_PLAN_STATUS_PAST_DUE = 'past_due';
export const SUBSCRIPTION_PLAN_STATUS_INCOMPLETE = 'incomplete';
export const SUBSCRIPTION_PLAN_STATUS_INCOMPLETE_EXPIRED = 'incomplete_expired';
export const SUBSCRIPTION_PLAN_STATUS_UNPAID = 'unpaid';

export const SUBSCRIPTION_PLAN_TYPE_EDUCATOR = 'educator';
export const SUBSCRIPTION_PLAN_TYPE_TEACH = 'teach';
export const SUBSCRIPTION_PLAN_TYPE_PERSONAL = 'personal';
export const SUBSCRIPTION_PLAN_TYPE_PORTAL = 'portal';
export const SUBSCRIPTION_PLAN_TYPE_CUSTOM = 'custom';

export const SUBSCRIPTION_PLAN_BILLING_CYCLE_MONTHLY = 'monthly';
export const SUBSCRIPTION_PLAN_BILLING_CYCLE_YEARLY = 'yearly';
export const SUBSCRIPTION_PLAN_BILLING_CYCLE_QUARTERLY = 'quarterly';
export const SUBSCRIPTION_PLAN_BILLING_CYCLE_HALF_YEARLY = 'half_yearly';

export const SUBSCRIPTION_PLAN_PAYMENT_INTERVAL_MONTHLY = 'month';
export const SUBSCRIPTION_PLAN_PAYMENT_INTERVAL_YEARLY = 'year';

export const SUBSCRIPTION_PLAN_BILLING_METHOD_NONE = 'null';
export const SUBSCRIPTION_PLAN_BILLING_METHOD_INVOICE = 'invoice';
export const SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE = 'braintree';
export const SUBSCRIPTION_PLAN_BILLING_METHOD_STRIPE = 'stripe';

export const SUBSCRIPTION_PLAN_ACTION_SUBSCRIBE_EDUCATOR = 'subscribe-educator';
export const SUBSCRIPTION_PLAN_ACTION_UPGRADE_EDUCATOR = 'upgrade-educator';
export const SUBSCRIPTION_PLAN_ACTION_UPDATE_PAYMENT_METHOD =
  'update-payment-method';
export const SUBSCRIPTION_PLAN_ACTION_CANCEL = 'cancel';
export const SUBSCRIPTION_PLAN_ACTION_CANCEL_EDUCATOR = 'cancel-educator';
export const SUBSCRIPTION_PLAN_ACTION_SUBSCRIBE_TEACHCOMAU =
  'subscribe-teachcomau';

export const SUBSCRIPTION_PLAN_ACTION_CANCEL_PERSONAL = 'cancel-personal';
export const SUBSCRIPTION_PLAN_ACTION_SUBSCRIBE_PERSONAL = 'subscribe-personal';

export const SUBSCRIPTION_PLAN_ACTION_MANAGE = 'manage';

export const SUBSCRIPTION_PLAN_GATEWAY_STRIPE = 'stripe';
export const SUBSCRIPTION_PLAN_GATEWAY_BRAINTREE = 'braintree';

export declare type UserSubscriptionPlanStatus =
  | 'pending'
  | 'trial'
  | 'active'
  | 'cancel_pending'
  | 'cancelled'
  | 'expired'
  | 'past_due';

export declare type UserSubscriptionPlanBillingMethod =
  | 'invoice'
  | 'braintree'
  | 'stripe'
  | null;

export declare type UserSubscriptionPlanBillingCycle =
  | 'monthly'
  | 'yearly'
  | 'quarterly'
  | 'half_yearly'
  | null;

export type UserSubscriptionStripeConnectStatus =
  | 'no_revenue_share'
  | 'ol_revenue_no_stripe_account'
  | 'no_stripe_account'
  | 'pending'
  | 'active';

export type OlConnectCurrency = 'AUD' | 'MYR';

export type Tax = 'no_tax' | 'sst';

export const TAX_LABEL: {
  [key: string]: string;
} = {
  no_tax: 'N/A - 0%',
  sst: 'SST - 6%',
};

export type RevenueShare = {
  olConnectCurrency: OlConnectCurrency;
  percentage: number;
  processingFees: boolean;
  tax: 'no_tax' | 'sst';
  useOlConnect: boolean;
};

export declare type UserSubscriptionPlanSummary = {
  id: string;
  name: string;
  userId: string;
  type: SubscriptionPlanType;
  status: UserSubscriptionPlanStatus;
  billingCycle: UserSubscriptionPlanBillingCycle;
  billingMethod: UserSubscriptionPlanBillingMethod;
  billingCycleStart: string | null;
  expiryDate: string | null;
  nextPaymentDate: string | null;
  planId: string;
  hasReachedEducatorLimit?: boolean;
  hasReachedLearnerLimit?: boolean;
  isActive: boolean;
  learnerLimit: number;
  educatorLimit: number | null;
  portalLimit?: number;
  notes?: string;
  cancelAtPeriodEnd?: boolean;
  stripeConnectStatus: UserSubscriptionStripeConnectStatus;
  revenueShare: RevenueShare | null;
};

export declare type UserSubscriptionPlan = {
  userSubscriptionPlanId: string;
  planName: string;
  planType: SubscriptionPlanType;
  status: UserSubscriptionPlanStatus;
  statusLabel: string[];
  nextPaymentLabel: string;
  amountLabel: string;
  billingMethod: string;
  endDate: string;
};

export declare type UserSubscriptionPlans = UserSubscriptionPlan[];

export declare type UserCumuluativeUsageData = {
  billingCycleStart: string;
  billingCycleEnd: string;
  numLearners: number;
};

export declare type UserDailyUsageData = {
  date: string;
  numLearners: number;
};

export const SUBSCRIPTION_ROLE_ADMIN = 'SUBSCRIPTION_ROLE_ADMIN';
export const SUBSCRIPTION_ROLE_OWNER = 'SUBSCRIPTION_ROLE_OWNER';
